module.exports = __webpack_public_path__ + "static/media/article-icon-black.06d81beb.svg";